import axios from '@/shared/api/axios';

const getCompanyDetailInfo = async (cId: string) => {
    const response = await axios.get(`/v1/hub/companies/${cId}`);
    return response.data;
};

export default getCompanyDetailInfo;

